import { call, put, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';
import Metrics from 'services/metrics';
import { LOAD_USER_LOGIN_SSO } from '../constants';
import { pendingUserPhone, errorUserPhone, pinSentUserPhone } from '../actions';
import { getUserLogInSSO } from '../service';
import { setProfileLastTouch, setProfileLastTouchFavorited } from '../../../utils/Socialization';

export function* doSendPhone({ payload }) {
  yield put(pendingUserPhone());
  try {
    const params = {
      numberfield: payload.phone,
    };

    const request = yield call(getUserLogInSSO, params);

    const { status, errors, response } = request;
    if (response?.lasttouch) {
      if (response.lasttouch.profile)
        setProfileLastTouch(response.lasttouch.profile);
      if (response.lasttouch.favorited)
        setProfileLastTouchFavorited(response.lasttouch.favorited);
    }
    let metricsParams = {};
    if (Number(status === 200) && _.isEmpty(errors)) {
      const sent = _.get(response, 'sent', false);
      yield put(pinSentUserPhone(sent));
    } else if (Number(status !== 200) && !_.isEmpty(errors)) {
      const error = _.get(errors, '0');
      yield put(errorUserPhone(error));
      const eventLabel = errors[0].message;
      metricsParams = {
        event: 'Error',
        eventCategory: 'Errores',
        eventAction: 'Error',
        eventLabel,
      };
    }
    Metrics.newEvent(metricsParams);
  } catch (error) {
    yield put(errorUserPhone(error));
  }
}

export default function* sendPhoneSaga() {
  yield takeLatest(LOAD_USER_LOGIN_SSO.ACTION, doSendPhone);
}

// const type = data.errors.type;
// const code = data.errors.code;
// const eventLabel =
//   code !== null && code !== undefined
//     ? type === 'internal'
//       ? `Registro Usuario y contraseña-WPLAY_API_${code}-Int`
//       : type === 'external' &&
//         `Registro Usuario y contraseña-WPLAY_API_${code}-Ext`
//     : (type === 'internal' || type === 'external') &&
//       'Registro Usuario y contraseña-WPLAY_API_00001-Int';

// // Set metrics
